module.exports = __webpack_public_path__ + "img/del_SDcard_data.1c305d51.png";